import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import './AppStyle.js';
import { useIsAuthenticated } from "@azure/msal-react";

import AppLayout from './src/components/AppLayout/index.js';
import LoginScreen from './src/screens/LoginScreen/index.js';
import HomeScreen from './src/screens/HomeScreen/index.js';
import StandardizationScreen from './src/screens/StandardizationScreen/index.js';
import PrivateRoute from './src/screens/PrivateRoute/PrivateRoute.js';
import NotFound from './src/screens/NotFound/index.js';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import 'reactjs-popup/dist/index.css';

import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

import Modal from 'react-modal';
import { useUser } from './src/context/user/index.js';
import LoadingScreen from './src/components/LoadingScreen/index.js';
import ProjectListScreen from './src/screens/ProjectListScreen/index.js';
import {useEffect} from "react";

// Leave this if required for debugging in the future
// class DebugRouter extends Router {
//   constructor(props){
//     super(props);
//     console.log('initial history is: ', JSON.stringify(this.history, null,2))
//     this.history.listen((location, action)=>{
//       console.log(
//         `The current URL is ${location.pathname}${location.search}${location.hash}`
//       )
//       console.log(`The last navigation action was ${action}`, JSON.stringify(this.history, null,2));
//     });
//   }
// }

// this are all the modal's default styles
Modal.defaultStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.35)',
    zIndex: 1000,
  },
  content: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%',
    marginRight: '200px',
    border: '1px solid #ccc',
    boxShadow: '0px 10px 33px 4px rgba(0,0,0,0.2)',
    background: '#fff',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '4px',
    outline: 'none',
    padding: 0,
    maxHeight: '95%',
  },
};

Modal.setAppElement('#root');

const App = () => {
  const { isLoading: isUserLoading, user, findUser } = useUser();
  const isAuthenticated = useIsAuthenticated();
  let location = useLocation();
  console.log(location.pathname);
  console.log(isAuthenticated);
  console.log(user);

  useEffect(() => {
    if (!isAuthenticated && user) {
      console.log('removing lingering user data');
      localStorage.removeItem('userData');
    } else if (isAuthenticated && !user) {
      findUser();
    }
  }, [isAuthenticated, user]);

  if (isUserLoading) {
    return <LoadingScreen />;
  }

  return (
    <>
      <ToastContainer
        autoClose={2000}
        hideProgressBar
      />
      <Switch>
        <Route
          path='/login'
          component={LoginScreen}
        />
        {isAuthenticated && <AppLayout>
          <PrivateRoute
            path='/home'
            component={HomeScreen}
          />
          <PrivateRoute
            path='/projects'
            component={ProjectListScreen}
          />
          <PrivateRoute
            path='/standardization'
            component={StandardizationScreen}
          />
        </AppLayout>}
        <Redirect
          path='*'
          to='/login'
        />
      </Switch>
    </>
  );
}

export default App;
